import { get } from '../../Common/utils';

import { dropDownDefault } from './constants';

const modifiersToString = (...modifiers) => {
  let result = '';
  modifiers.forEach(modifier => {
    if (modifier) {
      result = `${result}${modifier}, `;
    }
  });
  result = result.substring(0, result.length - 2);

  return result;
};

const normalizeAggregators = (aggregators = []) =>
  dropDownDefault.concat(
    aggregators.map(aggregator => ({
      label: get(aggregator, 'aggregatorID', ''),
      value: get(aggregator, 'aggregatorID', ''),
    })),
  );

const normalizePayers = (payers = []) =>
  dropDownDefault.concat(
    payers.map(payer => {
      const id = get(payer, 'payerID', '');

      return {
        label: id ? `${get(payer, 'payerName', '')} (${id})` : '',
        value: id,
      };
    }),
  );

const normalizeProcedures = (procedures = []) =>
  procedures.map(procedure => ({
    procedureCode: get(procedure, 'procedureCode', ''),
    procedureName: get(procedure, 'procedureName', ''),
    programCode: get(procedure, 'programCode', ''),
    programName: get(procedure, 'programName', ''),
    aggregatorProcedureCode: get(procedure, 'aggregatorProcedureCode', ''),
    modifiers: modifiersToString(
      get(procedure, 'modifier1', ''),
      get(procedure, 'modifier2', ''),
      get(procedure, 'modifier3', ''),
      get(procedure, 'modifier4', ''),
    ),
    type: get(procedure, 'type', ''),
    isProcedureCode: get(procedure, 'isProcedureCode', ''),
    notes: get(procedure, 'notes', ''),
  }));

export { normalizeAggregators, normalizePayers, normalizeProcedures };
